import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
export default function({ state, commit, dispatch }, schedule) {
    commit('startSchedulingPatient', schedule.patient)
    dayjs.extend(utc)
    dayjs.extend(timezone)
    try {
        if(state.timezone) {
            let time = schedule.time
            time += new Date(schedule.time).getTimezoneOffset() * 60000
            let timeObj = new Date(time)
            schedule.time = dayjs.tz(timeObj.toISOString().split('T')[0] + ' 07:00',  state.timezone).valueOf() + 123
        }
    } catch (error) {
        console.error('Got error with schedule timing', error)
    }
   


    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : schedule.provider) + '/patient/' + schedule.patient + '/schedule',
        data: schedule
    }, {
        root: true
    })
    .then((response) => {
        commit('finishSchedulingPatient', schedule.patient)
        dispatch('getProviderOverview', (state.id ? state.id : schedule.provider))
        if(schedule.time > new Date().setHours(0, 0, 0, 0))
            commit('updateProviderUpcoming', {
                patient: schedule.patient,
                schedule_time: schedule.time,
                provider: state.id ? state.id : schedule.provider
            })
        commit('updatePatient', response)
		return response
    })
    .catch((error) => {
        commit('finishSchedulingPatient', schedule.patient)
		console.log(error)
		throw error
    })
}
